// Layout authed: client-side gate via /api/me. 401 → redirect /sign-in.
import { createFileRoute, Outlet, Link, redirect } from '@tanstack/react-router';
import { useMe } from '@/lib/hooks';

export const Route = createFileRoute('/_authed')({
  component: AuthedLayout,
});

function AuthedLayout() {
  const { data, isLoading, error } = useMe();
  if (isLoading) {
    return <main><span className="spinner" /> Carregando…</main>;
  }
  if (error || !data?.user) {
    // useMe já dispara redirect via fetch helper; este é fallback
    window.location.href = '/sign-in';
    return null;
  }
  const user = data.user;
  return (
    <>
      <header className="topbar">
        <div style={{ fontWeight: 700 }}>Simplifica · Admin v2</div>
        <nav className="nav">
          <Link to="/socios" activeProps={{ className: 'active' }}>Sócios</Link>
        </nav>
        <div className="nav">
          <span style={{ fontSize: '0.8rem', color: 'var(--muted)' }}>{user.nome ?? user.email}</span>
          <a href="/sign-out" className="btn btn-ghost" style={{ fontSize: '0.75rem' }}>Sair</a>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </>
  );
}
